"use strict";

export default class FILTER{
    /**
     * 
     * @param {{emptyCategories:boolean|string,verbose:boolean,persistInSessionStorage:boolean}} configuration 
     */
    constructor(configuration) {
        //configuration (should be an object)
        this.verbose = configuration?.verbose??false;
        this.emptyCategories = configuration?.emptyCategories??false;//true : keep empty categories, else do not bind them, hide : create an "empty category" but dont show it 
        this.persistInSessionStorage =configuration?.persistInSessionStorage??false;

        const controllers = document.querySelectorAll('[data-controller]');
        const containers = document.querySelectorAll('[data-container]');
        this.pairs = [];
        if(this.verbose)console.log("started");
        for (const key in Array.from(controllers)) {
            const controller = controllers[key];
            const associatedContainer = Array.from(containers).find(c => c.dataset.container === controller.dataset.controller);
            if (associatedContainer === undefined)
                throw `no container found for ${controller}`;
            this.pairs.push(this.createPair(controller, associatedContainer,key));
        }
    }
    createPair(controller, container,pairName)
    {
        const categories = {};
        const items = [];
        const root = this;
        //analyze existing controller button to recreate all categories
        const buttons = controller.getElementsByTagName("button");
        for (const button of buttons) {
            let category = button.dataset.category.trim();
            const newcategory = { name: category, IsFiltreActive: false, HTMLButton:button, salt: Math.random().toString(16).split(".")[1]};
            categories[category] = newcategory;
            if(this.verbose)console.info(`created "${category}" category`);
            
            button.addEventListener("click",(event)=> {
                if(this.verbose)console.info(`Clicked "${newcategory.name}" button, toggling IsFiltreActive to ${!newcategory.IsFiltreActive}`);
                //toggle value
                newcategory.IsFiltreActive = !newcategory.IsFiltreActive;
                //update
                updateCategory(newcategory);
                //if(this.verbose)console.log(categories);
            });
            if(this.verbose)console.info(`created "${newcategory.name}" button listner`);
        }

        //analyze item container to binds each item to their categories
        for (const childNode of container.children) {
            const itemCategoriesArray = childNode.dataset.categories?.trim().split(",").map(i => i.trim());
            const itemcategories = [];
            if(!this.emptyCategories)itemCategoriesArray = itemCategoriesArray.filter(i=> i!=="")//remove empty categories
            
            if(this.verbose)console.info(`Categories for "${childNode.innerText}" item are "${itemCategoriesArray}"`);
            itemCategoriesArray.forEach(category => {itemcategories.push(categories[category]);});

            const newItem = {
                HTMLItem: childNode,
                Categories: itemcategories,
                IsVisible: () =>{
                    let filtredCount = Object.values(categories).filter(v=>v.IsFiltreActive===true).length;
                    return (
                    (filtredCount >= 1 && newItem.Categories.reduce((res, cur) => res || cur.IsFiltreActive, false))
                    //|| filtredCount === newItem.Categories.length && newItem.Categories.every(v=>v.IsFiltreActive===true)
                    ) ;
                }
                //newItem.Categories.reduce((res, cur) => res ? !cur.IsFiltreActive:cur.IsFiltreActive, false)//res && cur.IsFiltreActive
            };
            items.push(newItem);
        }

        //restore categories state from storage (if any)
        if(this.persistInSessionStorage)
        {
            let categoriesFromStorage=sessionStorage.getItem(pairName+"-categorystate");
            if(categoriesFromStorage != null)
            {
                categoriesFromStorage=JSON.parse(categoriesFromStorage);
                if(this.verbose)console.log(categoriesFromStorage);
                //update categories from storage (if any)
                for (const categoryKey in categories) {
                    categories[categoryKey].IsFiltreActive=categoriesFromStorage[categoryKey].IsFiltreActive;
                    updateCategory(categories[categoryKey]);
                }
                if(this.verbose)console.log(`Restored categories from session storage`);
            }
        }
        function updateCategory(category)
        {
            let isAllCategoryUnchecked = UpdateCategoryReset();
            if(root.verbose)console.log(`Is all category un-checked : ${isAllCategoryUnchecked}`);
            
            if (category.IsFiltreActive)
                category.HTMLButton.classList.add("activeFilter");
            else
                category.HTMLButton.classList.remove("activeFilter");
            
            items.forEach(item => {
                if(root.verbose)console.log(`"${item.HTMLItem.innerText}" visibility is now ${item.IsVisible()}`);
                if (item.IsVisible() | isAllCategoryUnchecked) {
                    item.HTMLItem.classList.remove("hide");
                    window.setTimeout(()=> {
                        item.HTMLItem.style.display = "block";
                    }, 100);
                }
                else {
                    item.HTMLItem.classList.add("hide");
                    window.setTimeout( () =>{
                        item.HTMLItem.style.display = "none";
                    }, 100);
                }
            });
            if(root.persistInSessionStorage)sessionStorage.setItem(pairName+"-categorystate",JSON.stringify(categories));
        }
        function UpdateCategoryReset() {
            return Object.values(categories).every((v)=>v.IsFiltreActive===false);//!Object.values(categories).reduce((res, cur) => res || cur.IsFiltreActive, false); 
        }
        return { pairName,controller, container,items };
    }
}

